var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: ['container', _vm._isMobile() ? 'mobile' : '']
  }, [_c('a-card', {
    attrs: {
      "bordered": false
    }
  }, [_c('a-form', [_c('a-form-item', {
    attrs: {
      "label": "活动界次",
      "labelCol": {
        xs: {
          span: 8
        },
        sm: {
          span: 2
        }
      },
      "wrapperCol": {
        xs: {
          span: 16
        },
        sm: {
          span: 22
        }
      }
    }
  }, [_c('j-dict-select-tag', {
    attrs: {
      "defaultShowAll": true,
      "type": "radioButton",
      "trigger-change": true,
      "dictCode": "event_orders"
    },
    on: {
      "change": _vm.eventChange
    },
    model: {
      value: _vm.queryParam.eventId,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "eventId", $$v);
      },
      expression: "queryParam.eventId"
    }
  })], 1), _c('a-form-item', {
    attrs: {
      "label": "排序方式",
      "labelCol": {
        xs: {
          span: 8
        },
        sm: {
          span: 2
        }
      },
      "wrapperCol": {
        xs: {
          span: 16
        },
        sm: {
          span: 22
        }
      }
    }
  }, [_c('a-radio-group', {
    attrs: {
      "button-style": "solid"
    },
    on: {
      "change": _vm.getList
    },
    model: {
      value: _vm.queryParam.orderBy,
      callback: function callback($$v) {
        _vm.$set(_vm.queryParam, "orderBy", $$v);
      },
      expression: "queryParam.orderBy"
    }
  }, [_c('a-radio-button', {
    attrs: {
      "value": "time"
    }
  }, [_vm._v("\n            最近更新\n          ")]), _c('a-radio-button', {
    attrs: {
      "value": "view"
    }
  }, [_vm._v("\n            播放最多\n          ")]), _c('a-radio-button', {
    attrs: {
      "value": "like"
    }
  }, [_vm._v("\n            推荐最多\n          ")])], 1)], 1)], 1), _c('a-divider'), _vm.loading ? _c('a-skeleton') : _vm._e(), _c('a-list', {
    attrs: {
      "grid": {
        gutter: _vm._isMobile() ? 12 : 24,
        lg: 4,
        md: 3,
        sm: 2,
        xs: 1
      },
      "dataSource": _vm.dataSource,
      "pagination": _vm.pagination
    },
    scopedSlots: _vm._u([{
      key: "renderItem",
      fn: function fn(item) {
        return _c('a-list-item', {}, [_c('a-card', {
          attrs: {
            "bordered": false
          },
          on: {
            "click": function click($event) {
              return _vm.toDetail(item);
            }
          }
        }, [_c('div', {
          staticClass: "img-zoom"
        }, [_c('img', {
          staticClass: "cover",
          attrs: {
            "src": item.cmsCover_url,
            "alt": ""
          }
        })]), _c('h3', {
          staticClass: "title"
        }, [_vm._v(_vm._s(item.cmsTitile))])])], 1);
      }
    }])
  })], 1), _c('LightBox', {
    ref: "lightbox",
    attrs: {
      "showLightBox": false,
      "showCaption": true,
      "media": _vm.lightBoxMedia
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };